import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';
import ShareViaCopyPopup from '../../../../components/Share/UprezForm/ShareViaCopyPopup';

const mapStateToProps = (state: StoreState) => {
	const {
		sharePanel: {
			isShareViaCopyPopupOpen,
			shareViaCopyData,
			pin,
			isProcessing,
			copyMode,
			theme,
			callbackAction,
		},
	} = state;

	return {
		isDisplayed: isShareViaCopyPopupOpen,
		resourceList: shareViaCopyData,
		pin,
		isProcessing,
		copyMode,
		theme,
		callbackAction,
	};
};

export default connect(mapStateToProps)(ShareViaCopyPopup);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Share/UprezForm/ShareViaCopyPopup/index.tsx